export enum EAttributesGroupSelectTypes {
  FILTER = 'filter',
  SELECT = 'selectable'
}
